import request from '@/utils/request.js';

// 收益明细列表 /api/v1/tob/income-list
function incomeList(data) {
    return request({
        url: '/api/v1/tob/income-list',
        method: 'get',
        params:data
    })
}

// [机构后台]-推广老师管理 /api/v1/tob/admin-teacher-list
function getExtendTeachList(data) {
    return request({
        url: '/api/v1/tob/admin-teacher-list',
        method: 'get',
        params:data
    })
}

// 推广者列表 /api/v1/tob/promoter-users
function promoterUsers(data) {
    return request({
        url: '/api/v1/tob/promoter-users',
        method: 'get',
        params:data
    })
}


// 招生报名列表 /api/v1/tob/recruit-signup-list
function getRecruitSignupList(data) {
    return request({
        url: '/api/v1/tob/recruit-signup-list',
        method: 'get',
        params:data
    })
}

export default{
    incomeList,
    promoterUsers,
    getExtendTeachList,
    getRecruitSignupList,
}